export const aboutData = {
  title: "Who I am",
  description1:
    "My name's Ahmed Raja. I'm a software developer based in Durban, South Africa.",
  description2:
    "I'm currently a Software Development Engineer at Amazon, where I work on building scalable and impactful backend solutions. I specialize in backend development with expertise in Java, Python, and C#. In my spare time, I enjoy working on personal projects, watching sports, and gaming. I'm passionate about continuous learning and exploring new technologies to stay at the forefront of software development.",
  image: 2,
};
